import * as Sentry from "@sentry/react";

// One report per event type and alias and session is enough to spot a new shape.
const reported = new Set<string>();

/**
 * Reports event attributes whose value had a shape the event detail panel does not
 * know and was therefore shown as raw JSON (see `splitEventAttributes`).
 */
export const reportUnformattedEventAttributes = (
    aliases: string[],
    eventType: string | undefined,
    eventId: string | undefined,
) => {
    aliases.forEach((alias) => {
        const key = `${eventType}:${alias}`;
        if (reported.has(key)) return;
        reported.add(key);
        if (process.env.NODE_ENV === "development") {
            console.warn(`Event attribute "${alias}" (${eventType}) has an unknown shape and is shown as raw JSON`, { eventId });
        }
        Sentry.captureMessage("Event attribute rendered as raw JSON", {
            level: "warning",
            tags: { eventType, alias },
            extra: { eventId },
        });
    });
};
